import { defineStore } from 'pinia'

export const useGmoPageStore = defineStore('gmoPageStore', {
  state: () => ({
    gmoUrl: null
  })
})
